/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from "react";
import { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";
import {
  faPlusCircle,
  faRotate,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import APIVariableForm from "../APIVariableForm/APIVariableForm";

function LoadingIndicator() {
  return <FontAwesomeIcon icon={faRotate} spin />;
}

// custom menu for select component with tooltip
function VariableSelectMenu(props) {
  return (
    <>
      <div
        style={{
          position: "absolute",
          zIndex: 1500,
          bottom: 48,
          left: 0,
          right: 0,
          background: "#ffb",
          color: "black",
          border: "solid 1px #ddd",
          borderRadius: 4,
          boxShadow: "2px 2px 5px 2px #ddd",
          padding: 10,
        }}
      >
        Select a variable from the list or start typing variable name to create
        a new variable
      </div>
      <components.Menu {...props}>{props.children}</components.Menu>
    </>
  );
}

// custom option with delete button
function VariableSelectOption(props) {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <components.Option {...props} />
      {props.selectProps.isDeleteable && (
        <button
          type="button"
          className="btn btn-outline-danger btn-sm"
          style={{ marginLeft: -80 }}
          onClick={() => props.selectProps.handleDeleteAPIVariable(props.value)}
        >
          Delete <FontAwesomeIcon icon={faTrash} />
        </button>
      )}

      {props.data.__isNew__ && (
        <FontAwesomeIcon style={{ marginLeft: -30 }} icon={faPlusCircle} />
      )}
    </div>
  );
}

export default function APIVariableSelect({ onCreateNew, ...props }) {
  const [APIVariables, setAPIVariables] = useState([]);
  const [isVariablesLoading, setIsVariablesLoading] = useState(false);
  const APIVariableOptions = () =>
    APIVariables.map((v) => ({ value: v.id, label: v.name }));
  const [newVariableName, setNewVariableName] = useState(null);

  const getVariables = () => {
    setIsVariablesLoading(true);
    fetch(`/library/get/variablesdata`)
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        }
        toast.error("Could not get variables!");
        return [];
      })
      .then((data) => {
        setAPIVariables(data);
        setIsVariablesLoading(false);
      });
  };

  const createAPIVariable = (newVariable) => {
    setIsVariablesLoading(true);
    fetch(`/library/variable/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": document
          .getElementsByName("csrf-token")[0]
          .getAttribute("content"),
      },
      body: JSON.stringify(newVariable),
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        }
        toast.error("Could not create the variable!");
        return [];
      })
      .then((data) => {
        setIsVariablesLoading(false);
        if (data.status === "success") {
          getVariables();
          onCreateNew({
            value: data.DevicesVarName.id,
            label: data.DevicesVarName.name,
          });
          setNewVariableName(null);
        }
      });
  };

  const handleDeleteAPIVariable = (variableId) => {
    setIsVariablesLoading(true);
    fetch(`/library/variable/remove/${variableId}`)
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        }
        toast.error("Could not delete the variable!");
        return [];
      })
      .then(() => {
        setIsVariablesLoading(false);
        getVariables();
      });
  };

  return (
    <>
      <CreatableSelect
        {...props}
        placeholder="Select a variable"
        options={APIVariableOptions()}
        components={{
          ...props.components,
          Menu: VariableSelectMenu,
          Option: VariableSelectOption,
          LoadingIndicator,
        }}
        isValidNewOption={(v) => v}
        onCreateOption={setNewVariableName}
        handleDeleteAPIVariable={handleDeleteAPIVariable}
        onFocus={getVariables}
        isLoading={isVariablesLoading}
      />
      {newVariableName && (
        <APIVariableForm
          variable={{
            name: newVariableName,
            delimiter: ":",
            endDelimiter: ";",
            listDelimiter: ",",
            isMultiLine: false,
          }}
          onSubmit={createAPIVariable}
          onCancel={() => setNewVariableName(null)}
        />
      )}
    </>
  );
}
